<script setup lang="ts">
defineProps<{ autocomplete?: string; placeholder?: string; invalid?: boolean }>()
const model = defineModel<string>({ required: true })
const shown = ref(false)
</script>

<template>
  <span class="pw">
    <input
      v-model="model"
      class="input pw__input"
      :type="shown ? 'text' : 'password'"
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      :aria-invalid="invalid"
      required
    />
    <button
      type="button"
      class="pw__toggle"
      :aria-label="shown ? 'Hide password' : 'Show password'"
      :aria-pressed="shown"
      @click="shown = !shown"
    >
      <AppIcon :name="shown ? 'eye-off' : 'eye'" :size="20" />
    </button>
  </span>
</template>

<style scoped>
.pw {
  position: relative;
  display: block;
}

.pw__input {
  padding-right: 48px;
}

.pw__toggle {
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--gray-500);
}

.pw__toggle:hover {
  color: var(--gray-900);
}
</style>
